const searchType = {
  nameAndDOB: 'Name and DOB',
  nameAndDOBWithAddressReturned: 'Name and DOB w/Address Returned',
  idNumber: 'ID Number',
  idNumberWithAddressReturned: 'ID Number w/Address Returned',
};

export default searchType;
